import React, { useContext } from 'react';
import { Box } from 'wix-style-react';
import { SourceButton } from '../../../PageElements/SourceButton';
import { StoreContext } from '../../../../appContext/StoreProvider';
import ContactOwner from './ContactOwner';
import style from './memberActionItems.scss';
import { useExperiments } from '@wix/wix-experiments-react';

export const MemberActionItems = ({ artifactId, memberSrc }) => {
  const { store } = useContext(StoreContext);
  const { experiments } = useExperiments({ suspense: false });
  const contactOwnerFeatureEnabled = experiments.enabled(
    'specs.wix-docs.ContactOwnerButton',
  );

  const shouldShowSourceLinkButton =
    store.viewer.viewerConfig.displayOptions.showSourceLink && memberSrc;

  return (
    <div className={style.actionButtonsContainer}>
      {(contactOwnerFeatureEnabled || shouldShowSourceLinkButton) && (
        <Box align="right">
          {contactOwnerFeatureEnabled && (
            <ContactOwner artifactId={artifactId} />
          )}
          {shouldShowSourceLinkButton && (
            <Box
              marginLeft={contactOwnerFeatureEnabled ? '12px' : '0'}
              dataHook="member-source-button"
            >
              <SourceButton href={memberSrc} />
            </Box>
          )}
        </Box>
      )}
    </div>
  );
};
